import { useEffect } from "react";
import { BUSINESS } from "@/lib/brand";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function SEO({ title, description, path = "/" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BUSINESS}` : `${BUSINESS} — Makeup Artists in Lucknow`;
    document.title = fullTitle;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", `${window.location.origin}${path}`);
  }, [title, description, path]);
  return null;
}
